import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";

import AccordionV2 from "@Components/Accordian";
import Image from "@Components/Image";
import SupportsIcon from "@Icons/SupportsIcon";
import VerifiedIcon from "@Icons/VerifiedIcon";

import CustomAccordionItem from "./components/CustomAccordionItem";
import InfoIcon from "@Icons/InfoIcon";

import styles from "./USPSection.module.scss";
import PriceMatchGuaranteeIcon from "@Icons/PriceMatchGuaranteeIcon";
import PriceMatchGuarantee from "./components/PriceMatchGuarantee";
import Disclaimer from "./components/Disclaimer";
// import { isPaymentActive } from "@Pages/Search/components/SearchListItem/helper";
// import InstantBookingIcon from "@Icons/InstantBookingIcon";
import USPStrip from "./components/USPStrip";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import config from "@Config/index";
import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";
import formatTrustpilotCount from "@Utils/formatTrustpilotCount";
import addCommasToNumber from "@Utils/addCommasToNumber";
import useIsMiniProgram from "hooks/useIsMiniProgram";
import PropertyViews from "../PropertyDetailsSection/components/PropertyViews";
import GradientDividerIcon from "@Icons/GradientDividerIcon";

const PropertyUSPs = ({ isDesktop = false, showPropertyViews = false }) => {
  const { inventory } = useSelector(
    ({ propertyPageData, bookFormData }: AppState) => ({
      inventory: propertyPageData?.data || bookFormData.data,
    }),
    shallowEqual,
  );
  const { trustPilotReviewCount } = useSelector(({ appData }: AppState) => appData);
  const { t } = useTranslationHook();
  const isMiniProgram = useIsMiniProgram();
  const formattedTrustPilotCount = formatTrustpilotCount(trustPilotReviewCount);
  const commaAddedTrustpilotCount = addCommasToNumber(trustPilotReviewCount);

  const meta_general_facts = inventory?.meta_general_facts || inventory?.meta_facts || [];
  const meta_community_facts = inventory?.meta_community_facts || {};

  // removing payment type changes, need to show for all
  // const isPaymentActiveValue = isPaymentActive(inventory);

  const getItems = () => {
    const TAGS = [];

    // if (isPaymentActiveValue) {
    //   const message = t("propertypage.propertyusp.instantbookingsubtitle");
    //   // eslint-disable-next-line no-nested-ternary

    //   TAGS.push({
    //     leftIcon: <InstantBookingIcon />,
    //     class_name: "is-main-red-light",
    //     title: t("propertypage.propertyusp.instantbookingtitle"),
    //     // accordianTitle: "With this property, you get",
    //     // isDivider: true,
    //     content: message,
    //   });
    // }
    TAGS.push({
      leftIcon: <PriceMatchGuaranteeIcon />,
      class_name: "",
      title: t("propertypage.propertyusp.lowestpriceguaranteedtitle"),
      // accordianTitle: "With amber, you'll always get",
      content: t("propertypage.propertyusp.lowestpriceguaranteedsubtitle"),
      description: <PriceMatchGuarantee />,
    });
    TAGS.push({
      leftIcon: <VerifiedIcon />,
      class_name: "",
      title: t("propertypage.propertyusp.verifiedpropertiestitle"),
      content: t("propertypage.propertyusp.verifiedpropertiessubtitle"),
    });
    TAGS.push({
      leftIcon: <SupportsIcon />,
      class_name: "",
      title: t("propertypage.propertyusp.personalassistancetitle"),
      content: t("propertypage.propertyusp.personalassistancesubtitle"),
    });
    TAGS.push({
      leftIcon: (
        <Image
          src={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/homepage-review.svg`} // use from env later
          alt="GreenStarIcon"
          height="20"
          width="20"
          isNotLazy={!isMiniProgram}
        />
      ),
      titleClass: "star",
      starClassname: "starWrapper",
      title: `${formattedTrustPilotCount}+ ${t("Reviews")}`,

      content: t("propertypage.propertyusp.starwrapper", {
        TRUSTPILOT_REVIEW: commaAddedTrustpilotCount,
      }),
      // rightIcon: `${config.IMAGE_STATIC_URL}/images/trustpilot_stars.png?auto=format`,
    });

    const disclaimer =
      inventory?.description?.find((item: any) => item.name === "booking_disclaimer") || {};

    const updatedDisclaimer = Object.keys(disclaimer).length
      ? [
          {
            title: t("propertypage.propertyusp.disclaimertitle"),
            color: "warning.5",
            leftIcon: <InfoIcon />,
            content: (
              <div
                className={styles.disclaimerContent}
                dangerouslySetInnerHTML={{ __html: replaceAmberDomainInLinks(disclaimer.value) }}
              />
            ),
            description: <Disclaimer content={disclaimer.value} />,
          },
        ]
      : [];

    return [...TAGS, ...updatedDisclaimer];
  };

  const formattedUSP = getItems();

  return (
    <>
      {isDesktop ? (
        <AccordionV2
          data={formattedUSP}
          CustomAccordionItem={CustomAccordionItem}
          isDesktop={isDesktop}
        />
      ) : (
        <div className={showPropertyViews ? styles.uspCardWrapper : undefined}>
          <USPStrip uspData={formattedUSP} isPropertyPage={showPropertyViews} />
          {showPropertyViews && (
            <>
              <div className={styles.dashedDivider}>
                <GradientDividerIcon width="100%" />
              </div>
              {meta_general_facts && meta_general_facts.length > 0 && (
                <PropertyViews
                  metaGeneralFacts={meta_general_facts}
                  metaCommunityFacts={meta_community_facts}
                />
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default wrapperHOC(PropertyUSPs, {
  componentName: "PropertyUSPs-PropertyPage",
  showForChina: true,
  showForWhiteLable: false,
});
